import React, { useState } from 'react';
import { MagnifyingGlassIcon, XMarkIcon } from '@heroicons/react/24/outline';

interface SKUSearcherProps {
  onSearch: (sku: string) => void;
  isLoading: boolean;
  onClear: () => void;
}

const SKUSearcher: React.FC<SKUSearcherProps> = ({ onSearch, isLoading, onClear }) => {
  const [sku, setSku] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (sku.trim()) {
      onSearch(sku.trim());
    }
  };

  const handleClear = () => {
    setSku('');
    onClear();
  };

  return (
    <div className="bg-gray-50 rounded-lg p-4 mb-6">
      <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3">
        <div className="flex-1">
          <label htmlFor="sku" className="block text-sm font-medium text-gray-700 mb-1">
            Buscar por SKU
          </label>
          <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <MagnifyingGlassIcon className="h-5 w-5 text-gray-400" />
            </div>
            <input
              type="text"
              id="sku"
              value={sku}
              onChange={(e) => setSku(e.target.value)}
              placeholder="Ingrese el SKU del producto (ej: UTE0169)"
              className="block w-full pl-10 pr-10 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
              disabled={isLoading}
            />
            {sku && (
              <button
                type="button"
                onClick={handleClear}
                className="absolute inset-y-0 right-0 pr-3 flex items-center"
                disabled={isLoading}
              >
                <XMarkIcon className="h-5 w-5 text-gray-400 hover:text-gray-600" />
              </button>
            )}
          </div>
        </div>
        
        <div className="flex gap-2 sm:items-end">
          <button
            type="submit"
            disabled={isLoading || !sku.trim()}
            className="px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isLoading ? 'Buscando...' : 'Buscar'}
          </button>
          
          <button
            type="button"
            onClick={handleClear}
            disabled={isLoading}
            className="px-4 py-2 bg-gray-300 text-gray-700 text-sm font-medium rounded-md hover:bg-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Limpiar
          </button>
        </div>
      </form>
      
      <p className="text-xs text-gray-500 mt-2">
        Ingrese el SKU del producto para buscar las remisiones que lo contienen
      </p>
    </div>
  );
};

export default SKUSearcher;
